import DateFnsUtils from '@date-io/date-fns';
import {
  Card, CardContent, CardHeader, createMuiTheme, Divider, Button, DialogContent, DialogActions, Dialog, Grid, Snackbar,
  TextField, DialogTitle
} from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import SaveIcon from '@material-ui/icons/Save';
import Select from '@material-ui/core/Select';
import SendIcon from '@material-ui/icons/Send';
import CloseIcon from '@material-ui/icons/CloseOutlined';
import {
  KeyboardDatePicker, MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import clsx from 'clsx';
import trLocale from 'date-fns/locale/tr';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import ProductPage from 'src/views/WorkOrder/Product';
import { useTranslation } from 'react-i18next';
import { connect, useSelector } from 'react-redux';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import { getUser } from 'src/utils/Common';
import axios from 'src/utils/axios';
import CircularProgress from '@material-ui/core/CircularProgress';
import ShuffleIcon from '@material-ui/icons/Shuffle';
import Alert from 'src/components/Alert';
import {
  getDefectRequest,
  getLabourRequest,
  getMaterialRequest,
  resetLabours,
  resetMaterials,
  resetDefects
} from '../../store/actions';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ProductWarrantyInfo from 'src/components/ProductWarrantyInfo';
import ErrorMessage from 'src/components/ErrorMessage';



const useStyles = makeStyles((theme) => ({
  root: {},
  fieldsGaranti: {
    backgroundColor: '#FFFFFF',
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1),
    }
  },
  contentGaranti: {
    minHeight: 430,
  },
}));
const siyah = '#424242';
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    },
  },
});
const localeMap = {
  tr: trLocale,
};
function Garanti({
  className, ReceiptNo, readonly, tasks, defectReducer, labourReducer, materialReducer,
  getDefectRequest,
  getLabourRequest,
  getMaterialRequest,
  resetLabours,
  resetMaterials,
  resetDefects,
  billingConsumer,
  setBillingConsumer
}) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');

  const { t: overViewTranslation } = useTranslation('overview');

  const locale = localStorage.getItem('i18nextLng');
  const [WarrantyData, setWarrantyData] = React.useState([]);
  const [Loading, setLoading] = useState(false);
  const SessionUser = getUser();
  let GarantiTipiDeger = '';
  let garantiTarihiDeger = '';
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [registrationPopUp, SetRegistrationPopUp] = useState(false);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message1')
  });
  const [open, setOpen] = React.useState(false);
  const [searchBillingConsumer, setSearchBillingConsumer] = useState('');
  const [optionsBillingConsumer, setOptionsBillingConsumer] = React.useState([]);
  const [billingRetailer, setBillingRetailer] = useState({});
  const [openProductWarrantyInfoDialog, setOpenProductWarrantyInfoDialog] = useState(false);
  const [productWarrantyData, setProductWarrantyData] = useState([]);
  const [invoiceDate, setInvoiceDate] = useState(false);
  const isOnline = useSelector((state) => state.status?.isOnline);

  const loading = open && optionsBillingConsumer.length === 0;
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  function GetProductWarrantyInfo(date) {
    var invoiceData = garantiTarihi == null && date == null ? false : true;
    setInvoiceDate(invoiceData);

    const formattedDate = garantiTarihi == null && date == null
      ? moment(new Date()).format("YYYY-MM-DD")
      : moment(date).format("YYYY-MM-DD");

    const request = {
      ProductCode: GarantiData[0].ModelCode,
      ProductionMonth: GarantiData[0].ProductionMonth,
      ProductionYear: GarantiData[0].ProductionYear,
      SerialNr: GarantiData[0].FullSerialNumber,
      Revision: 0,
      Date: formattedDate,
      RetailerId: GarantiData[0].RetailerId
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    axios.post('/GetProductWarrantyInfo', request, config)
      .then((response) => {
        setProductWarrantyData(response.data);
      })
      .catch((error) => {
        setProductWarrantyData([]);
      });
  }



  React.useEffect(() => {
    if (searchBillingConsumer && searchBillingConsumer.length > 3) {
      axios
        .get(
          `/BillingConsumerSearch/${searchBillingConsumer.toString()}`
        )
        .then(res => {
          if (res.data.length > 0) {
            // Assuming res.data is an array of objects with a 'Dsc' property
            setOptionsBillingConsumer(res.data);
          } else {
            setOptionsBillingConsumer([]);
          }
        })
        .catch(err => {
          setOptionsBillingConsumer([]);
        });
    }
  }, [searchBillingConsumer]);



  const GarantiData = readonly ? tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)) : loadBaslandiJob();



  useEffect(() => {
    if (!billingConsumer) {
      setBillingConsumer(GarantiData[0]?.BillingConsumer[0]);
    }
  }, [])

  if (GarantiData[0] === undefined) {
    GarantiTipiDeger = '';
    garantiTarihiDeger = null;
  } else if (GarantiData[0].WarrantyDate === '1900-01-01T00:00:00') {
    GarantiTipiDeger = GarantiData[0].WarrantyTypeId;
    garantiTarihiDeger = null;
  } else {
    GarantiTipiDeger = GarantiData[0].WarrantyTypeId;
    garantiTarihiDeger = GarantiData[0].WarrantyDate === '1900-01-01T00:00:00' ? null : GarantiData[0].WarrantyDate;
  }

  const updateText = data => {
    let job = loadBaslandiJob()[0];
    if (data.Type === 'Phone') {
      job = {
        ...job,
        BillingConsumer: [{
          Dsc: data.Dsc,
          Id: data.Id
        }],
        BillingRetailer: []
      };
      setBillingConsumer(data);
    }

    else if (data.Type === 'Retailer') {
      job = {
        ...job,
        BillingRetailer: [{
          Dsc: data.Dsc,
          Id: data.Id
        }
        ],
        BillingConsumer: []

      };
      setBillingRetailer(data);
      setBillingConsumer(data)
    }

    saveBaslandiJob(job);

  };

  useEffect(() => {
    setLoading(true);
    axios.get('/GetSiriusWarrantyType').then((response) => {
      const Deger = response.data;
      setWarrantyData(Deger);
      setLoading(false);
    }).catch((error) => {
      setWarrantyData([]);
      setLoading(false);
    });
  }, []);



  const handleWarrantyControl = () => {
    setOpenProductWarrantyInfoDialog(true);
    GetProductWarrantyInfo(garantiTarihi);
  };


  const [GarantiTipi, setGarantiTipi] = React.useState(GarantiTipiDeger);
  const [garantiTarihi, setGarantiTarihi] = React.useState(garantiTarihiDeger);
  if (GarantiData.length === 0) {
    return null;
  }


  const GarantiTipihandleChange = (event) => {
    const index = event.target.selectedIndex;
    let job = loadBaslandiJob()[0];

    if (job.WarrantyTypeId !== WarrantyData[index].WarrantyId) {
      setUyari(true);
      setUyariAciklama(t('warranty_changed_message'));
      resetLabours(job.ModelCode);
      resetMaterials(job.ModelCode);
      resetDefects();
      getDefectRequest(job.ModelCode, 1, []);
      getMaterialRequest(
        job.ModelCode,
        WarrantyData[index].WarrantyId,
        1,
        0,
        0,
        job?.ReceiptNo || 0
      );
      getLabourRequest(job.ModelCode, WarrantyData[index].WarrantyId, 1, job.ReceiptNo);
      job = { ...job, HIZMETLER: [], ISCILIKLER: [], MALZEMELER: [] };
    }
    job = {
      ...job,
      WarrantyTypeId: event.target.value,
      WarrantyTypeText: WarrantyData[index].FieldText,
      WarrantyGroupId: WarrantyData[index].WarrantyGroupId
    };

    saveBaslandiJob(job);
    setGarantiTipi(event.target.value);
    // handleWarrantyControlType(event.target.value);
  };

  const MerkezdenGarantiAl = (MerkezGarantiData) => {
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      WarrantyDate: MerkezGarantiData[0].WarrantyDate,
      WarrantyTypeId: MerkezGarantiData[0].WarrantyTypeId,
      WarrantyTypeText: MerkezGarantiData[0].WarrantyTypeText,
    };
    saveBaslandiJob(job);
    setGarantiTarihi(MerkezGarantiData[0].WarrantyDate);
    setGarantiTipi(MerkezGarantiData[0].WarrantyTypeId);

    const hizmetlerGaranti = [];
    const isciliklerGaranti = [];
    const malzemelerGaranti = [];
    let iscilik_toplam = 0;
    let malzeme_toplam = 0;
    for (let h = 0; h < defectReducer.selected.length; h++) {
      const hizmet = defectReducer.selected[h];
      hizmetlerGaranti.push({ HIZMET_KODU: hizmet });
      const labourArray = labourReducer[hizmet];
      if (labourArray && labourArray.length > 0) {
        for (let i = 0; i < labourArray.length; i++) {
          const iscilik = labourReducer.Data.filter((d) => d.LabourCode === labourArray[i])[0];
          if (iscilik) {
            isciliklerGaranti.push({
              ISCILIK_KODU: iscilik.LabourId,
              HIZMET_KODU: hizmet,
              KUL_ISCILIK_KODU: iscilik.LabourCode,
              ACIKLAMA: iscilik.LabourDesc,
              FIYAT: parseInt(job.GARANTI_TIPI) === 1 ? iscilik.PriceWithoutWarranty : iscilik.Price,
              FIYAT_LISTESI_ID: parseInt(job.GARANTI_TIPI) === 1 ? iscilik.PriceListIdWithoutWarranty : iscilik.PriceListId,
              FIYAT_KODU: iscilik.PriceId
            });
            iscilik_toplam += parseInt(job.GARANTI_TIPI) === 1 ? iscilik.PriceWithoutWarranty : iscilik.Price;
          }
        }
      }
      const materialArray = materialReducer[hizmet];
      if (materialArray && materialArray.length > 0) {
        for (let m = 0; m < materialArray.length; m++) {
          const malzeme = materialReducer.Data.filter((d) => d.MaterialCode === materialArray[m])[0];
          if (malzeme) {
            malzemelerGaranti.push({
              MALZEME_KODU: malzeme.MaterialId,
              HIZMET_KODU: hizmet,
              MALZEME_STOK_NO: malzeme.MaterialCode,
              ADET: materialReducer[malzeme.MaterialCode],
              ACIKLAMA: malzeme.MaterialDesc,
              FIYAT: malzeme.PriceWithWat,
              FIYAT_LISTESI_ID: malzeme.PriceListId,
              FIYAT_KODU: malzeme.PriceId
            });
            malzeme_toplam += materialReducer[malzeme.MaterialCode] * malzeme.PriceWithWat;
          }
        }
      }
    }
    job = {
      ...job,
      HIZMETLER: hizmetlerGaranti,
      ISCILIKLER: isciliklerGaranti,
      MALZEMELER: malzemelerGaranti,
      ISCILIK_TOPLAM: iscilik_toplam,
      MALZEME_TOPLAM: malzeme_toplam,
    };
  };

  const GarantiTarihihandleChange = (value) => {
    const Deger = moment(value).format('YYYY-MM-DD');
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      WarrantyDate: Deger,
    };
    saveBaslandiJob(job);
    setGarantiTarihi(Deger);
  };

  const SaveRegistration = () => {
    let job = loadBaslandiJob()[0];
    if (job.ProductId === "" || job.ProductionYear === 0 || job.ProductionMonth === 0 || job.SerialNumber === 0) {
      setresponseMessage({
        ErrorCode: '1000',
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }
    setLoading(true);
    const Data = {
      WorkOrderId: job.ReceiptNo,
      ProductId: job.ModelCode,
      Year: job.ProductionYear,
      Month: job.ProductionMonth,
      SerialNr: job.SerialNumber,
      CreateEmployeeId: SessionUser.TechnicianId
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetRegistration', Data, config)
      .then(response => {
        const Response = response.data[0];
        if (Response.ErrorCode == 0) {
          setresponseMessage({
            ErrorCode: Response.ErrorCode,
            ErrorDescription: t('success_message')
          });
          setUyariTip('success');
          setUyari(true);
        } else {
          setresponseMessage({
            ErrorCode: Response.ErrorCode,
            ErrorDescription: Response.ErrorDescription
          });
          setUyariTip('error');
          setUyari(true);
        }
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        SetRegistrationPopUp(false);
      });
  };

  return (
    <Card className={clsx(classes.root, className)}>
      <CardHeader title={t('Garanti_Detay')} />
      <Divider />
      <CardContent className={classes.contentGaranti}>
        {isOnline ? (
          Loading ? (
            <CircularProgress
              status="loading"
              style={{ marginLeft: '50%' }}
            />
          ) : (
            <form className={clsx(classes.root, className)}>
              <div className={classes.fieldsGaranti}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
                    <KeyboardDatePicker
                      margin="normal"
                      color="primary"
                      inputVariant="outlined"
                      id="GarantiTarihi"
                      label={t('Fatura_Tarihi')}
                      invalidDateMessage={t('hatali_tarih')}
                      format="dd.MM.yyyy"
                      variant="outlined"
                      value={garantiTarihi}
                      disabled={readonly}
                      onChange={(e) => GarantiTarihihandleChange(e)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </div>

              <div className={classes.fieldsGaranti}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <Select
                    fullWidth
                    native
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={GarantiTipi}
                    onChange={GarantiTipihandleChange}
                    disabled={readonly}
                  >
                    {WarrantyData.map((p) => (
                      <option key={p.WarrantyId} value={p.WarrantyId}>
                        {p.FieldText}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </div>

              {GarantiData[0]?.WarrantyGroupId === 2 && (
                <div className={classes.fieldsGaranti}>
                  <Autocomplete
                    id="asynchronous-demo"
                    open={open}
                    value={billingConsumer || GarantiData[0]?.BillingConsumer[0]}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    options={optionsBillingConsumer}
                    getOptionLabel={(option) => option.Dsc}
                    loading={loading}
                    onChange={(event, newInputValue) => {
                      if (newInputValue?.Dsc) {
                        updateText(newInputValue);
                      }
                    }}
                    disabled={readonly}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        size="small"
                        onChange={(e) => setSearchBillingConsumer(e.target.value)}
                        variant="outlined"
                        label={t('lblSearchBilling')}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loading && <CircularProgress color="inherit" size={20} />}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </div>
              )}

              <div className={classes.fieldsGaranti}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <Button
                    onClick={handleWarrantyControl}
                    color="primary"
                    variant="contained"
                    endIcon={<ShuffleIcon />}
                    disabled={!isOnline}
                  >
                    {t('lblWarrantyControl')}
                  </Button>
                </FormControl>
              </div>

              {SessionUser.TenantId === 49 && (
                <div className={classes.fieldsGaranti}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => SetRegistrationPopUp(true)}
                    disabled={readonly}
                    endIcon={<SaveIcon />}
                  >
                    {t('Registration')}
                  </Button>
                </div>
              )}

              {uyari && (
                <div className={classes.fieldsGaranti}>
                  <Alert
                    onClose={uyariKapat}
                    open={uyari}
                    message={uyariAciklama || ''}
                    variant={uyariTip}
                  />
                </div>
              )}
            </form>
          )
        ) : (
          <ErrorMessage message={t('Offline_Message')} />
        )}


      </CardContent>
      <Dialog
        open={registrationPopUp}
        fullWidth
        onClose={() => SetRegistrationPopUp(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        {
          uyari
            ? <Alert onClose={uyariKapat} open={uyari} message={responseMessage.ErrorDescription} variant={uyariTip} />
            : <div />
        }
        <DialogContent>
          <ProductPage DefectControlCheck={1} />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => SaveRegistration()}
            color="primary"
            fullWidth
            variant="contained"
            endIcon={<SendIcon />}
          >
            {t('lblSend')}
          </Button>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            endIcon={<CloseIcon />}
            onClick={() => SetRegistrationPopUp(false)}
          >
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openProductWarrantyInfoDialog} onClose={() => setOpenProductWarrantyInfoDialog(false)} fullWidth maxWidth="lg">
        <DialogTitle>{t('lblWarrantyInformation')}</DialogTitle>
        <DialogContent>
          <ProductWarrantyInfo data={productWarrantyData} invoiceDate={invoiceDate} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenProductWarrantyInfoDialog(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
}

Garanti.propTypes = {
  className: PropTypes.string,
};


export default connect(
  (state) => ({
    tasks: state.tasks1,
    defectReducer: state.defectReducer,
    labourReducer: state.labourReducer,
    materialReducer: state.materialReducer,
  }), {
  resetLabours,
  resetMaterials,
  resetDefects,
  getDefectRequest,
  getLabourRequest,
  getMaterialRequest,
}
)(Garanti);
